import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { spanToJSON, hasTracingEnabled, setHttpStatus, getCurrentScope, getIsolationScope, startInactiveSpan, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, getClient, spanToTraceHeader, getDynamicSamplingContextFromSpan, getDynamicSamplingContextFromClient } from '@sentry/core';
import { addFetchInstrumentationHandler, parseUrl, addXhrInstrumentationHandler, SENTRY_XHR_DATA_KEY, generateSentryTraceHeader, dynamicSamplingContextToSentryBaggageHeader, BAGGAGE_HEADER_NAME, browserPerformanceTimeOrigin, stringMatchesSomePattern } from '@sentry/utils';
import { instrumentFetchRequest } from '../common/fetch.js';
import { addPerformanceInstrumentationHandler } from './instrument.js';
import { WINDOW } from './types.js';
/* eslint-disable max-lines */

var DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\/(?!\/)/];
/** Options for Request Instrumentation */

var defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  enableHTTPTimings: true,
  // TODO (v8): Remove this property
  tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS
};
/** Registers span creators for xhr and fetch requests  */

function instrumentOutgoingRequests(_options) {
  var _traceFetch$traceXHR$ = _objectSpread({
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR
  }, _options),
      traceFetch = _traceFetch$traceXHR$.traceFetch,
      traceXHR = _traceFetch$traceXHR$.traceXHR,
      tracePropagationTargets = _traceFetch$traceXHR$.tracePropagationTargets,
      tracingOrigins = _traceFetch$traceXHR$.tracingOrigins,
      shouldCreateSpanForRequest = _traceFetch$traceXHR$.shouldCreateSpanForRequest,
      enableHTTPTimings = _traceFetch$traceXHR$.enableHTTPTimings;

  var shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : function (_) {
    return true;
  }; // TODO(v8) Remove tracingOrigins here
  // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
  // and we don't want to break the API. We can remove it in v8.

  var shouldAttachHeadersWithTargets = function shouldAttachHeadersWithTargets(url) {
    return shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);
  };

  var spans = {};

  if (traceFetch) {
    addFetchInstrumentationHandler(function (handlerData) {
      var createdSpan = instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans); // We cannot use `window.location` in the generic fetch instrumentation,
      // but we need it for reliable `server.address` attribute.
      // so we extend this in here

      if (createdSpan) {
        var fullUrl = getFullURL(handlerData.fetchData.url);
        var host = fullUrl ? parseUrl(fullUrl).host : undefined;
        createdSpan.setAttributes({
          'http.url': fullUrl,
          'server.address': host
        });
      }

      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }

  if (traceXHR) {
    addXhrInstrumentationHandler(function (handlerData) {
      var createdSpan = xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);

      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }
}

function isPerformanceResourceTiming(entry) {
  return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */


function addHTTPTimings(span) {
  var _ref = spanToJSON(span).data || {},
      url = _ref.url;

  if (!url || typeof url !== 'string') {
    return;
  }

  var cleanup = addPerformanceInstrumentationHandler('resource', function (_ref2) {
    var entries = _ref2.entries;
    entries.forEach(function (entry) {
      if (isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
        var spanData = resourceTimingEntryToSpanData(entry);
        spanData.forEach(function (data) {
          return span.setAttribute.apply(span, _toConsumableArray(data));
        }); // In the next tick, clean this handler up
        // We have to wait here because otherwise this cleans itself up before it is fully done

        setTimeout(cleanup);
      }
    });
  });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */


function extractNetworkProtocol(nextHopProtocol) {
  var name = 'unknown';
  var version = 'unknown';
  var _name = '';

  var _iterator = _createForOfIteratorHelper(nextHopProtocol),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var char = _step.value;

      // http/1.1 etc.
      if (char === '/') {
        var _nextHopProtocol$spli = nextHopProtocol.split('/');

        var _nextHopProtocol$spli2 = _slicedToArray(_nextHopProtocol$spli, 2);

        name = _nextHopProtocol$spli2[0];
        version = _nextHopProtocol$spli2[1];
        break;
      } // h2, h3 etc.


      if (!isNaN(Number(char))) {
        name = _name === 'h' ? 'http' : _name;
        version = nextHopProtocol.split(_name)[1];
        break;
      }

      _name += char;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (_name === nextHopProtocol) {
    // webrtc, ftp, etc.
    name = _name;
  }

  return {
    name: name,
    version: version
  };
}

function getAbsoluteTime() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return ((browserPerformanceTimeOrigin || performance.timeOrigin) + time) / 1000;
}

function resourceTimingEntryToSpanData(resourceTiming) {
  var _extractNetworkProtoc = extractNetworkProtocol(resourceTiming.nextHopProtocol),
      name = _extractNetworkProtoc.name,
      version = _extractNetworkProtoc.version;

  var timingSpanData = [];
  timingSpanData.push(['network.protocol.version', version], ['network.protocol.name', name]);

  if (!browserPerformanceTimeOrigin) {
    return timingSpanData;
  }

  return [].concat(timingSpanData, [['http.request.redirect_start', getAbsoluteTime(resourceTiming.redirectStart)], ['http.request.fetch_start', getAbsoluteTime(resourceTiming.fetchStart)], ['http.request.domain_lookup_start', getAbsoluteTime(resourceTiming.domainLookupStart)], ['http.request.domain_lookup_end', getAbsoluteTime(resourceTiming.domainLookupEnd)], ['http.request.connect_start', getAbsoluteTime(resourceTiming.connectStart)], ['http.request.secure_connection_start', getAbsoluteTime(resourceTiming.secureConnectionStart)], ['http.request.connection_end', getAbsoluteTime(resourceTiming.connectEnd)], ['http.request.request_start', getAbsoluteTime(resourceTiming.requestStart)], ['http.request.response_start', getAbsoluteTime(resourceTiming.responseStart)], ['http.request.response_end', getAbsoluteTime(resourceTiming.responseEnd)]]);
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */


function shouldAttachHeaders(url, tracePropagationTargets) {
  return stringMatchesSomePattern(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */
// eslint-disable-next-line complexity


function xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
  var xhr = handlerData.xhr;
  var sentryXhrData = xhr && xhr[SENTRY_XHR_DATA_KEY];

  if (!hasTracingEnabled() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) {
    return undefined;
  }

  var shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url); // check first if the request has finished and is tracked by an existing span which should now end

  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    var spanId = xhr.__sentry_xhr_span_id__;
    if (!spanId) return;
    var _span = spans[spanId];

    if (_span && sentryXhrData.status_code !== undefined) {
      setHttpStatus(_span, sentryXhrData.status_code);

      _span.end(); // eslint-disable-next-line @typescript-eslint/no-dynamic-delete


      delete spans[spanId];
    }

    return undefined;
  }

  var scope = getCurrentScope();
  var isolationScope = getIsolationScope();
  var fullUrl = getFullURL(sentryXhrData.url);
  var host = fullUrl ? parseUrl(fullUrl).host : undefined;
  var span = shouldCreateSpanResult ? startInactiveSpan({
    name: "".concat(sentryXhrData.method, " ").concat(sentryXhrData.url),
    onlyIfParent: true,
    attributes: _defineProperty({
      type: 'xhr',
      'http.method': sentryXhrData.method,
      'http.url': fullUrl,
      url: sentryXhrData.url,
      'server.address': host
    }, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.http.browser'),
    op: 'http.client'
  }) : undefined;

  if (span) {
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
  }

  var client = getClient();

  if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
    var _isolationScope$getPr = _objectSpread(_objectSpread({}, isolationScope.getPropagationContext()), scope.getPropagationContext()),
        traceId = _isolationScope$getPr.traceId,
        _spanId = _isolationScope$getPr.spanId,
        sampled = _isolationScope$getPr.sampled,
        dsc = _isolationScope$getPr.dsc;

    var sentryTraceHeader = span ? spanToTraceHeader(span) : generateSentryTraceHeader(traceId, _spanId, sampled);
    var sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dsc || (span ? getDynamicSamplingContextFromSpan(span) : getDynamicSamplingContextFromClient(traceId, client, scope)));
    setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
  }

  return span;
}

function setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    xhr.setRequestHeader('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
      // We can therefore simply set a baggage header without checking what was there before
      // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      xhr.setRequestHeader(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
    }
  } catch (_) {// Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
  }
}

function getFullURL(url) {
  try {
    // By adding a base URL to new URL(), this will also work for relative urls
    // If `url` is a full URL, the base URL is ignored anyhow
    var parsed = new URL(url, WINDOW.location.origin);
    return parsed.href;
  } catch (e) {
    return undefined;
  }
}

export { DEFAULT_TRACE_PROPAGATION_TARGETS, defaultRequestInstrumentationOptions, extractNetworkProtocol, instrumentOutgoingRequests, shouldAttachHeaders, xhrCallback };